module.exports = __webpack_public_path__ + "img/sd.47771bc8.png";